export default __webpack_public_path__ + "static/media/tiktok.b6cb9d03.svg";